module.exports = __webpack_public_path__ + "img/cssc.8e3fac80.png";